import React from "react";
import "./RightPanel.css";
import DetalleIntervencionMercado from "./DetalleIntervencionMercado";
import DetalleParqueIndustrial from "./DetalleParqueIndustrial";
import DetalleZonificacionIndustrial from "./DetalleZonificacionIndustrial";
import DetalleLoteIndustrial from "./DetalleLoteIndustrial";
import DetalleZonaIndustrial from "./DetalleZonaIndustrial";
import DetalleZonaEconomicaEspecial from "./DetalleZonaEconomicaEspecial";

const RightPanel = ({ isOpen, onClose, selectedItem, filteredData, selectedFilters, isSearchMode }) => {
  if (!selectedItem) return null;

  // selectedItem.kind discrimina qué componente de detalle renderizar:
  // - "parque"        → DetalleParqueIndustrial   (parques industriales /2)
  // - "zonificacion"  → DetalleZonificacionIndustrial (zonificación /3)
  // - "lote"          → DetalleLoteIndustrial     (unidades inmobiliarias /4)
  // - "zona"          → DetalleZonaIndustrial     (zonas industriales tab 3, /2)
  // - undefined       → DetalleIntervencionMercado (mercados minoristas)
  const renderContent = () => {
    switch (selectedItem.kind) {
      case "parque":
        return (
          <DetalleParqueIndustrial
            idIntervencion={selectedItem.id}
            nombre={selectedItem.nombre}
            onClose={() => onClose()}
          />
        );
      case "zona":
        return (
          <DetalleZonaIndustrial
            idIntervencion={selectedItem.id}
            idZonificacionInfra={selectedItem.idZonificacionInfra}
            nombre={selectedItem.nombre}
            onClose={() => onClose()}
          />
        );
      case "zed":
        return (
          <DetalleZonaEconomicaEspecial
            idIntervencion={selectedItem.id}
            nombre={selectedItem.nombre}
            onClose={() => onClose()}
          />
        );
      case "zonificacion":
        return (
          <DetalleZonificacionIndustrial
            idIntervencion={selectedItem.id}
            idZonificacionInfra={selectedItem.idZonificacionInfra}
            idZonificacion={selectedItem.idZonificacion}
            nombre={selectedItem.nombre}
            onClose={() => onClose()}
          />
        );
      case "lote":
        return (
          <DetalleLoteIndustrial
            idIntervencion={selectedItem.id}
            idLoteInfra={selectedItem.idLoteInfra}
            nombre={selectedItem.nombre}
            onClose={() => onClose()}
          />
        );
      default:
        return (
          <DetalleIntervencionMercado
            idIntervencion={selectedItem?.id}
            id_estado_intervencion={selectedItem?.id_estado_intervencion}
            id_modalidad={selectedItem?.id_modalidad}
            headerStyle={selectedItem.headerStyle}
            onClose={() => onClose()}
            fechaActualizacion={selectedItem.fechaActualizacion}
          />
        );
    }
  };

  return (
    <div
      id="popup-proyectos"
      className={`popup ${isOpen ? "open" : ""}`}
      onClick={(e) => {
        if (e.target.classList.contains("popup")) onClose();
      }}
    >
      <div className="popup-shell" onClick={(e) => e.stopPropagation()}>
        {renderContent()}
      </div>
    </div>
  );
};

export default RightPanel;
